import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import CountUp from 'react-countup'
import { GatsbyImage } from 'gatsby-plugin-image'
import VisibilitySensor from 'react-visibility-sensor'

const Counter = ({ slice }) => {
  var image = false
  if (slice.primary.image.gatsbyImageData) {
    image = true
  }

  return (
    <section className='component-counter mx-auto w-full max-w-screen-xl p-6 md:my-6'>
      <div className={`grid ${image && 'md:grid-cols-2'} bg-stone-200 relative z-10 rounded-md overflow-hidden`}>
        {slice.primary.image.gatsbyImageData && (
          <div className='h-full relative'>
            <GatsbyImage className='h-full md:absolute inset-0' image={slice.primary.image.gatsbyImageData} alt={slice.primary.image.alt || ''} />
          </div>
        )}
        <div>
          {slice.primary.title.text && (
            <div className={`prose prose-lg px-6 pt-6 md:px-8 md:pt-8 max-w-none ${slice.primary.text_align === true && 'text-center'}`}>
              <PrismicRichText field={slice.primary.title.richText} />
              <PrismicRichText field={slice.primary.text.richText} />
            </div>
          )}

          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div className={`flex ${image ? 'flex-col' : 'flex-row flex-wrap'} justify-evenly py-3`}>
                {slice.items.map((counter, index) => {
                  return (
                    <div key={`counter-${index}`} className='flex flex-col p-4 text-center leading-none md:p-6'>
                      <CountUp
                        className={`text-3xl font-bold md:text-5xl`}
                        delay={slice.primary.delay}
                        end={counter.final_number}
                        suffix={counter.suffix || ''}
                        prefix={counter.prefix || ''}
                        separator={counter.final_number.lenght > 4 ? ',' : ''}
                        decimal='.'
                        duration={slice.primary.duration}
                      />
                      <div>
                        <div className='text-base font-bold text-brand-blue md:text-2xl'>{counter.title.text}</div>
                        <div className='text-sm text-brand-blue md:text-lg'>{counter.text.text}</div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </VisibilitySensor>
        </div>
      </div>
    </section>
  )
}

export default Counter
